// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button Groups (Pills) */
.PillGroup_btnPills__0cDs- {
    width: auto;
    display: flex;
    flex-direction: row;
}

.PillGroup_pill__DzhF7 {
    margin-right: -1px;
    transition: none;
    color: black;
    background-color: white;
    border: 1px solid var(--color-lightui-accent-2);
    border-radius: 0;
    font-size: 11px;
    padding: 0 12px;
    height: 22px;
    line-height: 20px;
    outline: none;
}

.PillGroup_pill__DzhF7:first-child { border-radius: 4px 0 0 4px; }
.PillGroup_pill__DzhF7:last-child  { border-radius: 0 4px 4px 0 }

.PillGroup_pill__DzhF7:focus {
    position: relative;
    z-index: 1;
    box-shadow: inset 0 0 0 1px var(--color-blue-primary);
    border-color: var(--color-blue-primary);
}

.PillGroup_pill__DzhF7.PillGroup_active__iwdla,
.PillGroup_pill__DzhF7.PillGroup_active__iwdla:active,
.PillGroup_pill__DzhF7.PillGroup_active__iwdla:hover {
    color: white;
    background: var(--color-blue-primary);
    border-color: var(--color-blue-primary);
}

.PillGroup_pill__DzhF7:active:focus {
    box-shadow: none;
    border-color: var(--color-lightui-accent-2);
}

button.PillGroup_pill__DzhF7[disabled],
button.PillGroup_pill__DzhF7[disabled]:hover, 
button.PillGroup_pill__DzhF7[disabled]:focus {
    cursor: not-allowed;
    box-shadow: none;
    color: var(--color-lightui-accent-2);
}

/* ICONIZED PILLS */
.PillGroup_pill__DzhF7 [class*="icon-"],
.PillGroup_pill__DzhF7 [class^="icon-"] {
    font-size: 10px;
}

/* FIXED WIDTH Pills */
.PillGroup_btnPills__0cDs-.PillGroup_fixedWidth__8XANh .PillGroup_pill__DzhF7 {
    padding: 0 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Button/PillGroup.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA,qCAAoB,0BAA0B,EAAE;AAChD,qCAAoB,2BAA2B;;AAE/C;IACI,kBAAkB;IAClB,UAAU;IACV,qDAAqD;IACrD,uCAAuC;AAC3C;;AAEA;;;IAGI,YAAY;IACZ,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;;;IAGI,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA,mBAAmB;AACnB;;IAEI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["/* Button Groups (Pills) */\n.btnPills {\n    width: auto;\n    display: flex;\n    flex-direction: row;\n}\n\n.pill {\n    margin-right: -1px;\n    transition: none;\n    color: black;\n    background-color: white;\n    border: 1px solid var(--color-lightui-accent-2);\n    border-radius: 0;\n    font-size: 11px;\n    padding: 0 12px;\n    height: 22px;\n    line-height: 20px;\n    outline: none;\n}\n\n.pill:first-child { border-radius: 4px 0 0 4px; }\n.pill:last-child  { border-radius: 0 4px 4px 0 }\n\n.pill:focus {\n    position: relative;\n    z-index: 1;\n    box-shadow: inset 0 0 0 1px var(--color-blue-primary);\n    border-color: var(--color-blue-primary);\n}\n\n.pill.active,\n.pill.active:active,\n.pill.active:hover {\n    color: white;\n    background: var(--color-blue-primary);\n    border-color: var(--color-blue-primary);\n}\n\n.pill:active:focus {\n    box-shadow: none;\n    border-color: var(--color-lightui-accent-2);\n}\n\nbutton.pill[disabled],\nbutton.pill[disabled]:hover, \nbutton.pill[disabled]:focus {\n    cursor: not-allowed;\n    box-shadow: none;\n    color: var(--color-lightui-accent-2);\n}\n\n/* ICONIZED PILLS */\n.pill [class*=\"icon-\"],\n.pill [class^=\"icon-\"] {\n    font-size: 10px;\n}\n\n/* FIXED WIDTH Pills */\n.btnPills.fixedWidth .pill {\n    padding: 0 3px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnPills": `PillGroup_btnPills__0cDs-`,
	"pill": `PillGroup_pill__DzhF7`,
	"active": `PillGroup_active__iwdla`,
	"fixedWidth": `PillGroup_fixedWidth__8XANh`
};
export default ___CSS_LOADER_EXPORT___;
